
import { datalabHttp } from '@dbl/services/common';
import { AxiosRequestConfig } from 'axios';

// 新的数据报表接口
export function getSqlViewTable(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/tables',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}

// 数据源下拉筛选
export function getSqlViewScheme(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/get_table_search',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}
// 删除sql
export function deleteTableSqlView(params: any) {
  const options: AxiosRequestConfig = {
    url: '/api/v1/datalab/delete_table',
    method: 'post',
    data: params,
  };
  return datalabHttp(options);
}